var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 30.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #003189;\r\n        stroke-linecap: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #6c88bc;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "preference_transfer",
    "data-name": "preference transfer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6608",
    "data-name": "Group 6608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8558",
    "data-name": "Path 8558",
    className: "cls-1",
    d: "M8.91,4.4l3-2.99,2.98,2.99"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1228",
    "data-name": "Line 1228",
    className: "cls-1",
    x1: 11.9,
    y1: 2.93,
    x2: 11.9,
    y2: 7.88
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    className: "cls-2",
    cx: 2,
    cy: 3.91,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    className: "cls-2",
    cx: 22,
    cy: 3.91,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    className: "cls-2",
    cx: 2,
    cy: 14.91,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    className: "cls-2",
    cx: 12,
    cy: 14.91,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    className: "cls-2",
    cx: 22,
    cy: 14.91,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    className: "cls-2",
    cx: 2,
    cy: 25.91,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    className: "cls-2",
    cx: 22,
    cy: 25.91,
    r: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6496",
    "data-name": "Group 6496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    className: "cls-1",
    d: "M14.89,25.89l-3,2.99-2.98-2.99"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    className: "cls-1",
    x1: 11.9,
    y1: 27.36,
    x2: 11.9,
    y2: 22.41
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDefault);
export default __webpack_public_path__ + "static/media/move-default.6bc67b1f7119386e94013c945176cbc2.svg";
export { ForwardRef as ReactComponent };